// --- 订单管理 --- //

export default [
  {
    name: 'roomManage',
    path: '/receptionSystem/roomManagement/roomManage',
    meta: { title: '宾馆房间管理' },
    component: require('business/receptionSystem/roomManagement/roomManage/list.vue').default
  },
  {
    name: 'roomInfo',
    path: '/receptionSystem/roomManagement/roomInfo',
    meta: { title: '宾馆基本信息' },
    component: require('business/receptionSystem/roomManagement/roomInfo/list.vue').default
  },
  {
    name: 'roomInfoDetail',
    path: '/receptionSystem/roomManagement/roomInfoDetail',
    meta: { title: '信息编辑' },
    component: require('business/receptionSystem/roomManagement/roomInfo/detail.vue').default
  },
  {
    name: 'roomManageAdd',
    path: '/receptionSystem/roomManageAdd',
    meta: { title: '房间新增' },
    component: require('business/receptionSystem/roomManagement/roomManage/add.vue').default
  },
  {
    name: 'roomManageDetail',
    path: '/receptionSystem/roomManageDetail',
    meta: { title: '房间编辑' },
    component: require('business/receptionSystem/roomManagement/roomManage/detail.vue').default
  }
];
